import React from 'react';
import styles from './CommunityAutomationPropertesSingleStep.module.css';
import {
  COMMUNITY_ACTION_STEP_NAMES,
  COMMUNITY_EVENT_STEP_NAMES,
  COMMUNITY_EVENT_STEP_NAMES_LABELS
} from '../../../../../../helpers/constants';

export default ({
  selectedStep,
  selectedCommunityAutomationStepIndex,
  communityAutomation,
  setCommunityAutomation
}) => {
  const onChangeProperty = (property, value) => {
    const newSteps = communityAutomation.steps;
    newSteps[selectedCommunityAutomationStepIndex][property] = value;

    setCommunityAutomation({
      ...communityAutomation,
      steps: newSteps
    });
  };

  const maxPushTitleLength = 39;

  return (
    <div className={styles.container}>
      {selectedStep &&
      selectedStep.stepName ===
        COMMUNITY_EVENT_STEP_NAMES.NOT_OPEN_APP_IN_X_DAYS ? (
        <>
          <div className={styles.header}>
            <div className={styles.title}>Add event</div>
            <div className={styles.description}>
              {COMMUNITY_EVENT_STEP_NAMES_LABELS.NOT_OPEN_APP_IN_X_DAYS}
            </div>
            <div className={styles.fieldTitle}>Number of days</div>
            <div className={styles.fieldContainer}>
              <input
                className={`${styles.inputField} ${styles.amount1NarrowField}`}
                type="number"
                value={selectedStep.amount1 || ''}
                onKeyDown={evt =>
                  evt.key === 'ArrowDown' ||
                  evt.key === 'ArrowUp' ||
                  evt.key === 'e' ||
                  evt.key === 'E' ||
                  evt.key === '.' ||
                  evt.key === '-'
                    ? evt.preventDefault()
                    : null
                }
                onChange={e =>
                  onChangeProperty('amount1', parseInt(e.target.value, 10))
                }
                onWheel={e => e.target.blur()}
              />
            </div>
          </div>
        </>
      ) : null}
      {selectedStep &&
      selectedStep.stepName ===
        COMMUNITY_ACTION_STEP_NAMES.SEND_PUSH_NOTIFICATION ? (
        <div className={styles.header}>
          <div className={styles.title}>Add action</div>
          <div className={styles.description}>Push notification</div>
          <div className={styles.fieldTitle}>Title</div>
          <div className={styles.fieldContainer}>
            <input
              className={styles.inputField}
              value={selectedStep.title || ''}
              onChange={e => {
                if (e.target.value.length <= maxPushTitleLength) {
                  onChangeProperty('title', e.target.value);
                }
              }}
            />
            <span className={styles.inputCharacterCount}>
              {maxPushTitleLength -
                (selectedStep && selectedStep.title && selectedStep.title.length
                  ? selectedStep.title.length
                  : 0)}
            </span>
          </div>
          <div className={styles.fieldTitle}>Description</div>
          <div className={styles.fieldContainer}>
            <textarea
              className={styles.textareaField}
              onChange={e => onChangeProperty('description', e.target.value)}
              value={selectedStep.description}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};
